'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lostDealModal = require('./lostDeal.modal.html');

var _lostDealModal2 = _interopRequireDefault(_lostDealModal);

var _confirmDealModal = require('./confirmDeal.modal.html');

var _confirmDealModal2 = _interopRequireDefault(_confirmDealModal);

var _updateDpaConfirmModal = require('./updateDpaConfirm.modal.html');

var _updateDpaConfirmModal2 = _interopRequireDefault(_updateDpaConfirmModal);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiryConcludeController = function () {
  function EnquiryConcludeController(enums, $scope, $uibModal, $sce, $filter, $window, $state, loadingService, enquiryService, printService, $ngConfirm, authService, notificationService, userService) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, EnquiryConcludeController);
    this.enums = enums;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.$sce = $sce;
    this.$filter = $filter;
    this.$window = $window;
    this.$state = $state;
    this.loadingService = loadingService;
    this.enquiryService = enquiryService;
    this.printService = printService;
    this.$ngConfirm = $ngConfirm;
    this.authService = authService;
    this.notificationService = notificationService;
    this.userService = userService;

    this.enquiryLostReasons = this.convertEnumToKeyValueList(enums.ENQUIRY_LOST_REASON, true);

    this.updateState();

    $scope.$on('enquiry:initialized', function () {
      _this.updateState.bind(_this)();
    });

    this.authService.getLocationExtendedProperties('marketingSourceRequired');
  }

  (0, _createClass3.default)(EnquiryConcludeController, [{
    key: 'updateState',
    value: function updateState(state) {
      var ctrl = this;

      if (state) {
        ctrl.enquiry.state = state;
      }

      switch (ctrl.enquiry.state) {
        case ctrl.enums.ENQUIRY_STATE.Open:
          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Open</b>');
          break;

        case ctrl.enums.ENQUIRY_STATE.Lost:
          var reason = (0, _lodash.find)(ctrl.enquiryLostReasons, function (o) {
            return o.id === ctrl.enquiry.enquiryLostReason;
          }).name;
          ctrl.lostReason = reason;
          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Lost</b> <br> <b>Reason</b>: ' + reason + ' <br> <b>Addition Comments</b>: ' + (ctrl.enquiry.comments || ''));
          ctrl.enquiry.followUpWebLeadEmail = false;
          break;

        case ctrl.enums.ENQUIRY_STATE.Confirmed:
          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Confirmed</b> <br> <b>Delivery Date</b>: ' + ctrl.$filter('date')(ctrl.enquiry.deliveryDate, 'dd-MMMM-yyyy') + ' <br> <b>Addition Comments</b>: ' + (ctrl.enquiry.comments || ''));
          break;

        case ctrl.enums.ENQUIRY_STATE.Closed:
          ctrl.statusText = ctrl.$sce.trustAsHtml('<b>Closed</b>');
          break;
      }
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.$uibModalInstance.close();
    }
  }, {
    key: 'notifyFinance',
    value: function notifyFinance() {
      var ctrl = this;

      if (!ctrl.enquiry.enquiryVehicles || !ctrl.enquiry.enquiryVehicles.length) {
        alert('Please select a vehicle first');
        return;
      }

      ctrl.loadingService.showLoading('enquiryConclusion', 'Notifying Finance Team ...');

      ctrl.enquiryService.notifyFinance(ctrl.enquiry.enquiryId).then(function (response) {
        ctrl.enquiry.financeNotified = true;
        ctrl.enquiry.financeState = 'Awaiting Approval';

        ctrl.notificationService.sendFinanceCreatedNotification(ctrl.enquiry.enquiryId);
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquiryConclusion');
      });
    }
  }, {
    key: 'lostDeal',
    value: function lostDeal() {
      this.errMsg = '';

      //Check for Basic DPA before closing
      if (!this.authService.authData.currentLocation.basicDpaOptional && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
        this.fnUpdateDpa = this.showUpdateBasicDpa;

        this.$uibModalInstance = this.$uibModal.open({
          template: _updateDpaConfirmModal2.default,
          scope: this.$scope
        });

        return;
      }

      if (!this.authService.authData.currentLocation.allDpaOptional && !this.enquiry.isAllDpaSet && this.enquiry.state === this.enums.ENQUIRY_STATE.Confirmed && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
        this.fnUpdateDpa = this.showUpdateAllDpaYes;

        this.$uibModalInstance = this.$uibModal.open({
          template: _updateDpaConfirmModal2.default,
          scope: this.$scope
        });

        return;
      }

      if (this.authService.authData.currentLocation.marketingSourceRequired.enabled && !this.enquiry.enquirySourceId) {
        this.$ngConfirm({
          title: "Error",
          content: 'Please select an enquiry source first',
          type: 'red',
          columnClass: 'm',
          buttons: {
            ok: {
              text: 'Ok',
              btnClass: 'btn-default'
            }
          }
        });

        return;
      }

      this.$uibModalInstance = this.$uibModal.open({
        template: _lostDealModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'lostDealSelected',
    value: function lostDealSelected() {
      var ctrl = this;

      if (!ctrl.enquiry.enquiryLostReason) {
        ctrl.errMsg = 'Please selected a reason first';
        return;
      }

      ctrl.updateState(ctrl.enums.ENQUIRY_STATE.Lost);
      ctrl.closeModal();
    }
  }, {
    key: 'confirmDeal',
    value: function confirmDeal() {
      this.errMsg = '';

      /*if (this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet && !this.enquiry.isAllDpaSet) {
        this.$uibModalInstance = this.$uibModal.open({
          template: UpdateDpaConfirmTemplate,
          scope: this.$scope
        });
          return;
      }*/

      this.$uibModalInstance = this.$uibModal.open({
        template: _confirmDealModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'maybeLater',
    value: function maybeLater() {
      this.closeModal();

      if (this.enquiry.state !== this.enums.ENQUIRY_STATE.Confirmed) {
        this.$uibModalInstance = this.$uibModal.open({
          template: _confirmDealModal2.default,
          scope: this.$scope
        });
      }
    }
  }, {
    key: 'confirmDealSelected',
    value: function confirmDealSelected() {
      var _this2 = this;

      var ctrl = this;

      if (!ctrl.enquiry.deliveryDate) {
        ctrl.errMsg = 'Please selected a delivery date first';
        return;
      }

      ctrl.closeModal();

      ctrl.enquiryService.canConfirmEnquiry(ctrl.enquiry).then(function (response) {
        ctrl.updateState(ctrl.enums.ENQUIRY_STATE.Confirmed);
        ctrl.$scope.$emit('enquiryConclude:enquiryConfirmed');
      }).catch(function (err) {
        if (err.status === 400) {
          var key = err.data[0].key;

          if (key === 'linkedEnquiries') {
            _this2.warnLinkedEnquiries(err.data[0].value);
          } else {
            _this2.enquiryConfirmError(err.data[0].value);
          }
        } else if (err.status === 600) {} else {
          _this2.enquiryConfirmError("Enquiry could not be confirmed");
        }
      });
    }
  }, {
    key: 'enquiryConfirmError',
    value: function enquiryConfirmError(errMsg) {
      this.$ngConfirm({
        title: 'Enquiry Confirm Error',
        content: '' + errMsg,
        type: 'red',
        typeAnimation: false,
        columnClass: 'm',
        buttons: {
          ok: {
            text: 'Ok'
          }
        }
      });
    }
  }, {
    key: 'warnLinkedEnquiries',
    value: function warnLinkedEnquiries(linkedEnquiries, editArgs) {
      var _this3 = this;

      var arrLinkedEnquiries = linkedEnquiries.toString().replace(/\"/g, '').split(',');
      this.$ngConfirm({
        title: 'Multiple Enquiries',
        content: 'There are <b>' + arrLinkedEnquiries.length + '</b> other open enquirie(s) for this Contact with the same trade in vehicle. <br /><br />Confirming this enquiry will mark the other one\'s as lost.</br></br> <b>Are you sure you want to continue ?</b>',
        type: 'orange',
        typeAnimation: false,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Yes, Confirm this and Close others',
            btnClass: 'btn-primary',
            action: function action() {
              _this3.enquiryService.closeLinkedEnquiries(arrLinkedEnquiries).then(function () {
                _this3.updateState(_this3.enums.ENQUIRY_STATE.Confirmed);
                _this3.$scope.$emit('enquiryConclude:enquiryConfirmed');
              });
            }
          },
          no: {
            text: 'No, I will decide later',
            btnClass: 'btn-default',
            action: function action() {
              _this3.enquiry.deliveryDate = null;
              _this3.enquiry.comments = null;
            }
          }
        }
      });
    }
  }, {
    key: 'closeDeal',
    value: function closeDeal() {
      var ctrl = this;

      //Check for Basic DPA before closing
      if (!this.authService.authData.currentLocation.basicDpaOptional && !this.enquiry.isDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
        this.fnUpdateDpa = this.showUpdateBasicDpa;

        this.$uibModalInstance = this.$uibModal.open({
          template: _updateDpaConfirmModal2.default,
          scope: this.$scope
        });

        return;
      }

      if (!this.authService.authData.currentLocation.allDpaOptional && !this.enquiry.isAllDpaSet && this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && this.enquiry.contactType !== this.enums.CONTACT_TYPE.RetailFleet) {
        this.fnUpdateDpa = this.showUpdateAllDpaYes;

        this.$uibModalInstance = this.$uibModal.open({
          template: _updateDpaConfirmModal2.default,
          scope: this.$scope
        });

        return;
      }

      /*if (this.enquiry.contactType !== this.enums.CONTACT_TYPE.Trader && !this.enquiry.isAllDpaSet) {
        this.$uibModalInstance = this.$uibModal.open({
          template: UpdateDpaConfirmTemplate,
          scope: this.$scope
        });
          return;
      }*/

      var sure = ctrl.$window.confirm('Are you sure you want to Close this Enquiry. Selected Vehicle will be marked as sold in Stock and any Traded in Vehicles will be marked as Available in Stock');

      if (sure) {
        ctrl.updateState(ctrl.enums.ENQUIRY_STATE.Closed);
      }
    }
  }, {
    key: 'orderForm',
    value: function orderForm() {
      if (this.enquiry.contactType === this.enums.CONTACT_TYPE.Trader) {
        if (this.enquiry.enquirySubType === this.enums.ENQUIRY_SUBTYPE.BuyIn) {
          this.printService.nonSimiOrderForm(this.enquiry.enquiryId);
        } else {
          if (this.enquiry.isSimiMember) {
            /*
            * Show the Order form from DocuSign since it was requested for Signature
            * Check the status is either Created, or Signed by Customer or Completed
            */
            if (this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Created || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.CustomerSigned || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Completed) {
              this.showDocuSignAuth('viewSignedOrderForm');
            } else {
              this.printService.printSimiTradeOrderForm(this.enquiry.enquiryId);
            }
          } else {
            this.printService.printTradeOrderForm(this.enquiry.enquiryId, this.enquiry.isSimiMember);
          }
        }
      } else {
        if (this.enquiry.isSimiMember) {
          /*
          * Show the Order form from DocuSign since it was requested for Signature
          * Check the status is either Created, or Signed by Customer or Completed
          */
          if (this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Created || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.CustomerSigned || this.enquiry.signatureStatus === this.enums.SIGNATURE_STATUS.Completed) {
            this.showDocuSignAuth('viewSignedOrderForm');
          } else {
            this.printService.printSimiOrderForm(this.enquiry.enquiryId);
          }
        } else {
          this.printService.nonSimiOrderForm(this.enquiry.enquiryId);
        }
      }
    }
  }, {
    key: 'showUpdateBasicDpa',
    value: function showUpdateBasicDpa() {
      var dpa = {
        contactId: this.enquiry.contactId
      };

      if (this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Email || this.enquiry.enquiryOrigination === this.enums.ENQUIRY_ORIGINATION.Web) {
        dpa.verbalConsent = true;
      }

      this.$state.go('simpleDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, dpa: dpa });
    }
  }, {
    key: 'showUpdateAllDpaYes',
    value: function showUpdateAllDpaYes() {
      var marketing = {
        email: this.enquiry.marketing_Email,
        post: this.enquiry.marketing_Post,
        text: this.enquiry.marketing_Text,
        phone: this.enquiry.marketing_Phone
      };

      this.$state.go('allDpa', { contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, marketing: marketing });
    }
  }, {
    key: 'showRequestSignature',
    value: function showRequestSignature() {
      if (!this.enquiry.contactHasEmail) {
        this.$ngConfirm({
          title: 'ERROR',
          content: 'Cannot Request Signature. Contact does not have an email set',
          type: 'red',
          typeAnimation: false,
          columnClass: 'm',
          buttons: {
            tryAgain: {
              text: 'Close',
              btnClass: 'btn-danger'
            }
          }
        });

        return;
      } else {
        this.showDocuSignAuth('requestSignature');
      }
    }
  }, {
    key: 'showDocuSignAuth',
    value: function showDocuSignAuth(_action) {
      var _this4 = this;

      this.$ngConfirm({
        title: 'DocuSign Auth',
        contentUrl: 'templates/enquiry/docuSignAuthConsentTemplate',
        columnClass: 'm',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Yes, take me to DocuSign',
            btnClass: 'btn-primary',
            action: function action() {
              _this4.authService.docuSignLogin(_this4.enquiry.enquiryId, _action);
            }
          },
          no: {
            text: 'No, leave it',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'printOrderFormGuide',
    value: function printOrderFormGuide() {
      this.printService.printOrderFormGuid_CustomForm(this.enquiry.enquiryId);
    }
  }]);
  return EnquiryConcludeController;
}();

exports.default = EnquiryConcludeController;


// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryConclude/enquiryConclude.controller.js